import styled from 'styled-components';

export const InputWrapper = styled.div<{ isXS: boolean }>`
	display: flex;
	${({ isXS }) => ({
		gap: isXS ? '4px' : '16px',
	})}
`;
